export default __webpack_public_path__ + "static/media/hero-signet-cut.31c4f321.svg";